import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import { useRecoilValue } from "recoil";
import { CloseIcon } from "../../icons";
import { t } from "i18next";
import TrainSnapshot from "./TrainSnapshot";
import { heatmapModelState } from "../../recoil/upgrade";

interface SnapshotModalProps {
  open: boolean;
  onClose: () => void;
  projectId: number;
  serverAddress?: string;
}

export default function SnapshotModal({ open, onClose, projectId, serverAddress }: SnapshotModalProps) {
  const heatmapModel = useRecoilValue(heatmapModelState);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, fontSize: 16, fontWeight: 700 }}>
        {t("Snapshot")}
        {heatmapModel && (
          <Typography component="span" sx={{ fontSize: 13, color: "text.secondary" }}>
            {heatmapModel.label}
          </Typography>
        )}
        <IconButton onClick={onClose} sx={{ ml: "auto" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {open && <TrainSnapshot projectId={projectId} serverAddress={serverAddress} />}
      </DialogContent>
    </Dialog>
  );
}
